import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

export async function getServicePeriodsList(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/service-periods`)
  if (!response.ok) throw new Error('Error al obtener los periodos')
  return response.json()
}

export async function getServicePeriodSummary(parkId, period) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/service-periods/summary?period=${period}`)
  if (!response.ok) throw new Error('Error al obtener el resumen del periodo')
  return response.json()
}

export async function registerBlankService(periodId) {
  const response = await fetch(`${API_BASE}/service-periods/${periodId}/services`, { method: 'POST' })
  if (!response.ok) throw new Error('Error al registrar el servicio')
  return response.json()
}

export async function distributePeriod(periodId) {
  const response = await fetch(`${API_BASE}/service-periods/${periodId}/distribute`, { method: 'POST' })
  if (!response.ok) throw new Error('Error al distribuir el periodo')
  return response.json()
}

export async function getServicesMetrics(parkId, period) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/service-periods/metrics?period=${period}`)
  if (!response.ok) throw new Error('Error al obtener las métricas')
  return response.json()
}

export async function getCostPerM2History(parkId, period) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/service-periods/cost-history?period=${period}`)
  if (!response.ok) throw new Error('Error al obtener el historial')
  return response.json()
}

export async function getServicesForPeriod(parkId, period) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/service-periods/services-list?period=${period}`)
  if (!response.ok) throw new Error('Error al obtener los servicios')
  return response.json()
}

export async function updateService(serviceId, payload) {
  const response = await fetch(`${API_BASE}/services/${serviceId}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al actualizar el servicio')
  return response.json()
}

export async function deleteService(serviceId) {
  const response = await fetch(`${API_BASE}/services/${serviceId}`, { method: 'DELETE' })
  if (!response.ok) throw new Error('Error al eliminar el servicio')
  return response.json()
}

export async function getDistribution(parkId, period) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/service-periods/distribution?period=${period}`)
  if (!response.ok) throw new Error('Error al calcular la distribución')
  return response.json()
}

export async function getSchemesConfig(parkId, period) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/service-periods/schemes?period=${period}`)
  if (!response.ok) throw new Error('Error al obtener los esquemas')
  return response.json()
}

export async function saveScheme(serviceId, payload) {
  const response = await fetch(`${API_BASE}/services/${serviceId}/scheme`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al guardar el esquema')
  return response.json()
}

export async function getConfirmationSummary(parkId, period) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/service-periods/confirm-summary?period=${period}`)
  if (!response.ok) throw new Error('Error al obtener el resumen')
  return response.json()
}

export async function confirmDistribution(parkId, period) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/service-periods/confirm-distribution?period=${period}`, { method: 'POST' })
  if (!response.ok) throw new Error('Error al confirmar la distribución')
  return response.json()
}
async function exemptionResponse(response, fallback) {
  if (response.ok) return response.json()
  let message = fallback
  try { const body = await response.json(); if (body?.message) message = body.message } catch { /* sin cuerpo */ }
  throw new Error(message)
}

export async function saveServiceExemptions(periodId, payload) {
  const response = await fetch(`${API_BASE}/service-periods/${periodId}/exemptions`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  return exemptionResponse(response, 'No se pudo guardar la exención')
}

export async function deleteServiceExemption(periodId, exemptionId) {
  const response = await fetch(`${API_BASE}/service-periods/${periodId}/exemptions/${exemptionId}`, { method: 'DELETE' })
  return exemptionResponse(response, 'No se pudo quitar la exención')
}